import { render } from "./RoleCreateButton.vue?vue&type=template&id=31ca6aa1"
import script from "./RoleCreateButton.vue?vue&type=script&lang=js"
export * from "./RoleCreateButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__